import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from '@dbk/ui-react-utils';
import Parser from 'html-react-parser';
import Search from '@dbk/ui-search';
import { List, ListItem } from '@dbk/ui-list';
import Mark from "mark.js";
import LoginHeader from './login.header';
import Arrow from '../../../components/common/arrow';
import { CustomAccordion, AccordionItem } from '../../../common/components/custom-accordion';
import NavigationArrow from '../../../components/common/navigation-arrow';
import ui from '../../../../@extension/CH/src/data/ui.json';
import { PALETTE, RM_REGION, RM_ACCESS } from '../../../constants';
import config from '../../../data/settings.json';
import envConfig from '../../../../db-env-build';
import { KEY_CODE } from '../../../constants';
import SkipMainContent from '../../../components/app/skip-main-content';
import isEnterorSpaceKeyPressed from '../../../utils/isEnterorSpaceKeyPressed';
import Text, {H1, H4, H5} from '@dbk/ui-text';
class LoginFAQ extends Component {
  
    constructor(props) {
        super(props);

        const remoteUrl = window.location.origin + config.environments.relative.remoteUrl;
        this.state = {
            faqList: [],
            searchText: '',
            showSkipContent: false
        }
    }

    componentDidMount() {
        const { languages: { destLanguageCode }, auth: { setInvalidLogin} } = this.props;
        setInvalidLogin(false);

        const remoteUrl = window.location.origin + config.environments.relative.remoteUrl;
        let path;
        if (destLanguageCode === 'de-CH') {
            path = envConfig.rmRegion === RM_REGION ? ui.pdf.faqJsonGerman.replace("CH", "LUX") : ui.pdf.faqJsonGerman
        } else {
            path = envConfig.rmRegion === RM_REGION ? ui.pdf.faqJsonEnglish.replace("CH", "LUX") : ui.pdf.faqJsonEnglish
        }

        //let url = "https://chuat.mywealthasia.db.com/ebankinglux" + path;  // for local testing
        let url = remoteUrl + path;
        fetch(url, {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': 'true',
            'Access-Control-Allow-Methods': 'DELETE, HEAD, GET, OPTIONS, POST, PUT',
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'pragma': 'no-cache',
            'cache-control': 'no-store',
        })
            .then(resp => resp.json())
            .then((result) => {

                // const data = result.faqList;  // temp
                this.props.faq.setList(result);

                this.setState({
                    faqList: result[0].list,
                    isSelected: result[0].category,
                })
            }).catch((error) => {
                console.error(error);
            });

            if(document.querySelector('.faq-focus')) { 
                document.querySelector('.faq-focus').focus()
            }
    }

    componentWillUnmount() {
        this.props.faq.setList(null);
    }
    componentDidUpdate() {
        let ansDivs = document.querySelectorAll('#search-answer-container')
        ansDivs.forEach(ansDiv => {
            let anchorTags = ansDiv.querySelectorAll('a');

            if(anchorTags.length){ 
                anchorTags.forEach(anchorTag => {
                anchorTag.tabIndex = "-1";
                })
            }
        })
    }
        
    handleSearchFocus(e){
        if(e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY) && this.state.faqList.length > 0)
        {
            if(document.querySelector('#faq-content')){
                document.querySelector('#faq-content').focus();
              }
        }
    }

    getList = (item, e) => {
        
        if(isEnterorSpaceKeyPressed(e)){
            this.setState({ isSelected: item.category, faqList: item.list, searchText: ''  })
            if(e)
                this.setState({ showSkipContent: true })
        }

    }

    renderLeftSideBar = (item) => {
        return (
            <ListItem role="none" className="list-item" onClick={() => this.getList(item)} onKeyDown={(e) => this.getList(item,e)} selected={item.category === this.state.isSelected} tabIndex={-1}>
                <span className="h5-custom" tabIndex={0} >{item.category}</span>
                {this.state.showSkipContent && <SkipMainContent isFAQ ={this.state.showSkipContent} onHide = {() => this.setState({showSkipContent : false})}/>}
            </ListItem>
        )
    }

    onBackClick = (e) => {
        if(isEnterorSpaceKeyPressed(e)){
            (this.props.auth.authorised || this.props.rmAccess.userAdminGroup === RM_ACCESS.RM_DOC_UPLOAD) ? this.props.ui.history.goBack() : this.props.changePage('/login');
        }
    }

    handleSearchFAQ = (text) => {
        
        const { faq: { consolidatedList } } = this.props;
        const value = text.toLowerCase();
        var searchedArray = value.toLowerCase().trim().split(" ");  // convert searched string into array

        var resultantArray = [];
        var resultantIndex = [];
        var isSelectedItem;
        if (value.length >= 3) {
            consolidatedList.length > 0 && consolidatedList.map((item) => {
                item.list.length > 0 && item.list.map((item) => {
                    if(item.ans.toLowerCase().includes(value)){
                        resultantArray.push(item);
                    }
                })
            });
            isSelectedItem = null

        } else {
            resultantArray = consolidatedList[0].list;  // after clearing the search, reassign back the original list 
            isSelectedItem = consolidatedList[0].category;
        }

        this.setState({
            searchText: text,
            faqList: resultantArray,
            resultantIndex: resultantIndex,
            isSelected: isSelectedItem
        }, function() {
            const markInstance = new Mark(document.querySelectorAll("#search-answer-container"));
            markInstance.unmark({
                done: () => {
                    if (value.length >= 3) { markInstance.mark(text, { className: 'search-text-link'}); }
                }
              });
        })  
      
    }

    render = () => {

        const { i18n: { messages }, ui: { history: { goBack } }, auth: { authorised }, rmAccess } = this.props;
        return (
            <View className="login">
                {!authorised && (rmAccess.userAdminGroup !== RM_ACCESS.RM_DOC_UPLOAD)  && <View className="login-container margin-bottom-30">
                    <LoginHeader />
                </View >
                }
                
                <View className="faq-container">
                    <div className='display-flex-row'>
                        <div className='small-4 display-flex-row faq-title-container'>
                       
                            <div className="cursor-pointer" onClick={() => this.onBackClick()} onKeyDown={(e)=>this.onBackClick(e)}  tabIndex={0} aria-label={messages['app.documentUpload.button.back']} role="button">
                                <Arrow
                                    direction="left"
                                    width={10}
                                    height={16}
                                    color={PALETTE.secondaryActive}
                                    thickness={2}
                                    id="arrow_backLink_test"
                                /></div>
                            <H1 className="padding-left-20 faq-focus" testID="text_loginTitle_userLogin_test" tabIndex={0} aria-label={messages['app.login.accessibility.link.faq']}>{messages['app.login.faq']}</H1>
                        </div>
                        <div className='small-6 list-container' style={{ alignSelf: 'center' }} onKeyDown={(e)=>{this.handleSearchFocus(e)}}>
                            <Search
                                placeholder="Search FAQ" size="large" width={24} height={24} color="#999" fill="#999"
                                value={this.state.searchText}
                                onChange={this.handleSearchFAQ}
                                autoCorrect={false}
                                zIndex={-1}
                                selectTextOnFocus={false}
                                caretHidden={false}
                                contextMenuHidden={false} />
                        </div>
                    </div>

                    <div className='display-flex-row'>
                        {/* Left Side Bar   */}
                        <div className="small-4">
                            {this.props.faq.consolidatedList !== null && this.props.faq.consolidatedList.length > 0 && <List role="none" className="small-11 medium-11 max-width-none max-height-none">
                                {this.props.faq.consolidatedList.map(item => {
                                    return this.renderLeftSideBar(item)
                                })}
                            </List>
                            }
                        </div>
                        
                       
                        {/* FAQ Accordion Question and Answers */}
                        {this.state.faqList.length > 0 &&   <div className='small-6 padding-25 list-container'>
                            <H4 className="padding-15 margin-top-10 margin-bottom-10" tabIndex={0} id="faq-content">
                                {this.state.searchText.length < 3 ? this.state.isSelected : messages['app.faq.welcome.search']}
                            </H4>                          
                            <CustomAccordion
                                fullWidth
                                allowMultiple
                                activeItems={this.state.searchText.length >= 3 ? Array.from(this.state.faqList.keys()) : []}
                                categoryChange={this.state.isSelected}
                            >       
                                {this.state.faqList.length > 0 && this.state.faqList.map((item, index) =>                               
                                    <AccordionItem
                                                       
                                        renderIconForOpen={() => <NavigationArrow direction="up" size="large" color="primaryActive" tabIndex={0} ariaLabel={messages['app.faq.hideDetails']}/>}
                                        renderIconForClose={() => <NavigationArrow direction="down" size="large" color="primaryActive" tabIndex={0} ariaLabel={messages['app.faq.viewDetails']}/>}
                                        renderTitle={
                                            <H5 className='margin-top-10 margin-bottom-10 faq-title-header' tabIndex={0}>{item.qs}</H5>}
                                        itemKey={index}
                                        key={index}
                                    >
                                        <Text id="search-answer-container" >{Parser(item.ans)}</Text>
                                    </AccordionItem>)}
                            </CustomAccordion>
                        </div>}
                    </div>
                </View >
            </View>
        );
    }

}
export default createContainer({
    $queries: {
        i18n: {
            messages: true,
        },
        languages: {
            saveLanguageAtLogin: { $call: 'saveLanguageAtLogin' },
            getlanguages: { $call: 'getlanguages' },
            destLanguage: true,
            destLanguageCode: true,
        },
        config: {
            regionCode: true
        },
        changePage: { $call: 'ui.history.push' },
        ui: {
            history: {
                goBack: { $call: 'goBack' },
            }
        },
        faq: {
            consolidatedList: true,
            setList: { $set: 'consolidatedList' }
        },
        auth: {
            authorised: true,
            invalidLogin: true,
            setInvalidLogin: { $set: 'invalidLogin'}
        },
        rmAccess: {
            userAdminGroup: true
        }
    },
})(LoginFAQ);



